const doc = [({"empty":"Vazio", "payment_period":"Período de pagamento"})];
module.exports = doc.length <= 1 ? doc[0] : doc;